<template>
  <div class="site-wrap">
    <div class="site-mobile-menu site-navbar-target">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close">
          <span class="icon-close2 js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>
    <!-- .site-mobile-menu -->

    <!-- NAVBAR -->
    <NavBar @login="$emit('login')" @register="$emit('register')" />

    <!-- HOME -->
    <section class="home-section section-hero overlay" id="home-section">
      <div class="banner">
        <video autoplay muted loop style="height: 100vh">
          <source
            media="(min-width: )"
            srcset=""
            src="../assets/adliyaHD.mp4"
            type="video/mp4"
          />
        </video>
        <div class="container">
          <jobSearch
            class="jobListSearch"
            @changeSelectedItem="changeSelectedItem"
          />
        </div>
      </div>

      <!--      <div class="container">-->
      <!--        &lt;!&ndash; Search &ndash;&gt;-->
      <!--      -->
      <!--      </div>-->
    </section>

    <section class="site-section" id="joblist">
      <div class="container">
        <div class="mb-5 flex-center">
          <!-- Stat -->
        
            <JobStat />
          
        </div>
        <div class="mb-5">
          <joblist />
        </div>
      </div>
    </section>
    <section class="py-5 bg-image overlay-primary fixed overlay">
      <div class="box-container">
        <div class="box">
          <i
            class="fas fa-file-signature"
            style="color: #bc19e9; cursor: pointer"
          ></i>
          <h3 class="title">{{ $t("home.vacancyCount") }}</h3>
          <span class="counter" style="color: #bc19e9; cursor: pointer">{{
            totalElon > 0 ? totalElon : 0
          }}</span>
        </div>

        <div class="box">
          <i
            class="fas fa-user-tie"
            style="color: #c0392b; cursor: pointer"
          ></i>
          <h3 class="title">{{ $t("home.lavozim") }}</h3>
          <span class="counter" style="color: #c0392b; cursor: pointer">{{
            sumCountOfVacancy > 0 ? sumCountOfVacancy : 0
          }}</span>
        </div>

        <div class="box">
          <i
            class="fas fa-bullhorn"
            style="color: #f39c12; cursor: pointer"
          ></i>
          <h3 class="title">{{ $t("home.vacancy") }}</h3>
          <span class="counter" style="color: #f39c12; cursor: pointer">{{
            countStaffListVacancyNumber > 0 ? countStaffListVacancyNumber : 0
          }}</span>
        </div>

        <div class="box">
          <i class="fas fa-id-card" style="color: #16a085; cursor: pointer"></i>
          <h3 class="title">{{ $t("home.applicants") }}</h3>
          <span class="counter" style="color: #16a085; cursor: pointer">{{
            countSendDocumentEmployeeNumber > 0
              ? countSendDocumentEmployeeNumber
              : 0
          }}</span>
        </div>
        <div class="box">
          <i class="fas fa-file-archive " style="color: #007bff; cursor: pointer"></i>
          <h3 class="title" style="color: #007bff;">{{ $t("home.countEnnounmentInactive") }}</h3>
          <span class="counter" style="color: #007bff; cursor: pointer">{{
            totalArchive
          }}</span>
        </div>
      </div>
    </section>
    <!--    </section>-->
    <section class="fixed">
      <div class="hello">
        <yandex-map
          zoom="6"
          style="width: 100%; max-width: 100%; height: 70vh"
          :coords="coords"
          :scrollZoom="false"
        >
          <ymap-marker
            marker-id="123"
            v-for="(billboard, index) in depList"
            :key="index"
            :balloon-template="mapBalloon(billboard, index)"
            marker-type="placemark"
            :coords="[billboard.latitude, billboard.longitude]"
          ></ymap-marker>
        </yandex-map>
      </div>
    </section>

    <footer class="footer-section">
      <div class="container pt-3">
        <div class="mb-5 text-center">
          <h2 class="text-white font-weight-bold mt-3">
            {{ $t("home.company") }}
          </h2>
        </div>

        <div class="footer-social-icon single-cta">
          <span style="font-size: 26px">{{ $t("home.havola") }}</span>
          <a href="https://www.minjust.uz" target="_blank"
            ><i class="fas fa-globe"></i
          ></a>
          <a href="info@adliya.uz" target="_blank">
            <i class="far fa-envelope-open"></i>
          </a>
          <a href="https://www.facebook.com/groups/adliya/" target="_blank">
            <i class="fab fa-facebook-square"></i>
          </a>
          <a href="https://t.me/huquqiyaxborot" target="_blank" class="m-2">
            <i class="fab fa-telegram"></i>
          </a>
        </div>
        <div class="footer-cta pt-5">
          <div class="row">
            <div class="col-xl-4 col-md-4 mb-30">
              <div class="single-cta">
                <b-row>
                  <b-col cols="3"
                    ><i class="fas fa-phone float-right"></i
                  ></b-col>
                  <b-col cols="9">
                    <div class="cta-text float-left">
                      <h4>{{ $t("login.phone") }}</h4>
                      <span> 71 207 04 43</span>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="col-xl-4 col-md-4 mb-30">
              <div class="single-cta">
                <b-row>
                  <b-col cols="3">
                    <i class="far fa-envelope-open float-right"></i>
                  </b-col>
                  <b-col cols="9">
                    <div class="cta-text float-left">
                      <h4>{{ $t("login.email") }}</h4>
                      <span>info@adliya.uz</span>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="col-xl-4 col-md-4 mb-30">
              <div class="single-cta">
                <b-row>
                  <b-col cols="3">
                    <i class="fas fa-map-marker-alt float-right"></i>
                  </b-col>
                  <b-col cols="9">
                    <div class="cta-text float-left">
                      <h4>{{ $t("address.legal") }}</h4>
                      <span>5 Sayilgoh ko'chasi, Тошкент 100047</span>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>

        <b-container class="visitors-counter-container">
          <b-row
            align-h="end"
            class="visitors-counter-wrapper"
            id="visitorsCounterWrapper"
          >
            <!-- START WWW.UZ TOP-RATING -->
            <a :href="visitorsCounterLiskPath" target="_blank">
              <img
                :src="visitorCounterImagePathPart + top_r + top_rat"
                width="88"
                height="31"
                border="0"
                alt="Топ рейтинг www.uz"
              />
            </a>

            <NOSCRIPT
              ><a :href="visitorsCounterLiskPath" target="_top"
                ><img
                  height="31"
                  :src="visitorCounterNoscriptImagePath"
                  width="88"
                  border="0"
                  alt="Топ рейтинг www.uz" /></a
            ></NOSCRIPT>
            <!-- FINISH WWW.UZ TOP-RATING -->
          </b-row>
        </b-container>
      </div>
    </footer>
  </div>
</template>
<script>
import joblist from "@/components/Vacancylist";
import jobSearch from "@/components/VacancySearch";
import JobStat from "@/components/VacancyStat";
import NavBar from "@/views/NavBar.vue";
import axios from "axios";
import DepartmentService from "@/services/department/department.servise";
import { mapState } from "vuex";

export default {
  name: "home",
  data() {
    return {
      showModal: false,
      activeTab: "active",
      //
      coords: [41.311158, 69.27974],
      top_r:
        "id=45925&r=" +
        escape(document.referrer) +
        "&pg=" +
        escape(window.location.href),
      top_rat: "&col=0063AF&t=ffffff&p=DD7900",
      visitorsCounterLiskPath: "http://www.uz/ru/res/visitor/index?id=45925",
      visitorCounterImagePathPart: "https://cnt0.www.uz/counter/collect?",
      visitorCounterNoscriptImagePath:
        "https://cnt0.www.uz/counter/collect?id=45925&pg=http%3A//uzinfocom.uz&&col=0063AF&amp;t=ffffff&amp;p=DD7900",
      isComponentMounted: false,
    };
  },
  computed: {
    ...mapState("ennounsment", {
      totalElon: "total",
      sumCountOfVacancy: "sumCountOfVacancy",
      countSendDocumentEmployeeNumber: "countSendDocumentEmployeeNumber",
      countStaffListVacancyNumber: "countStaffListVacancyNumber",
      totalArchive : "totalArchive"
    }),
    ...mapState("department", {
      depList: "list",
      total: "total",
    }),
  },
  watch: {},
  methods: {
    changeSelectedItem(v) {
      window.scroll({ top: 750, behavior: "smooth" });
      // setTimeout( () => {
      //     document.documentElement.scrollTop = document.body.scrollTop = 700;
      // }, 400 );
    },
    login() {
      this.$emit("loginButton");
    },
    mapBalloon: function (billboard, index) {
      return `
      <div>
      <p><strong></strong>:${billboard.nameUz}</p>
      </div>
      `;
    },
  },
  components: {
    joblist,
    jobSearch,
    JobStat,
    NavBar,
  },

  created() {
  }
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-tab-btn {
  padding: 5px 15px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  border-radius: 6px;
  border: 1px solid var(--primary);
  color: var(--primary);
  transition: all ease 0.5s;
}
.c-tab-btn.active {
  background: var(--primary);
  color: white;
}
.c-tab-btn:first-of-type {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.c-tab-btn:last-of-type {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
/* TRANSITIONS PAGE */
/* / fade-speed/ */

.fade-speed-enter {
  opacity: 0;
  transform: rotateY(0deg) translateY(-15px);
}

.fade-speed-enter-active {
  transition: all 0.7s cubic-bezier(0.4, 0, 0, 1.54);
}

.fade-speed-leave-to {
  opacity: 0;
  transform: rotateY(-0deg) translateY(15px);
}

.left-enter {
  opacity: 0;
  transform: rotateY(0deg) translateX(-100%) scale(0.9) skewX(25deg);
}

.left-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0, 1.54) 0.3s;
}
.left-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0, 1.54);
}
.left-leave-to {
  opacity: 0;
  transform: rotateY(-0deg) translateX(100%) scale(0.9) skewX(-25deg);
}

/* // */

/* / scale-mode/ */

.right-enter {
  opacity: 0;
  transform: rotateY(0deg) translateX(100%) scale(0.9) skewX(25deg);
}

.right-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0, 1.54) 0.3s;
}
.right-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0, 1.54);
}
.right-leave-to {
  opacity: 0;
  transform: rotateY(-0deg) translateX(-100%) scale(0.9) skewX(-25deg);
}

/*.bg-image {*/
/*  background: ;*/
/*}*/

.box-container {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 100px;
  flex-wrap: wrap;
}

.box-container .box {
  text-align: center;
  margin: 100px 20px 20px 20px;
  height: 170px;
  width: 230px;
  position: relative;
  z-index: 1;
}

.box-container .box::before,
.box-container .box::after {
  content: "";
  position: absolute;
  top: 20px;
  bottom: 20px;
  right: 0;
  left: 0;
  z-index: -1;
  clip-path: polygon(13% 0%, 87% 0%, 100% 50%, 87% 100%, 13% 100%, 0% 50%);
  background: #bc19e9;
}

.box-container .box::after {
  top: 0px;
  bottom: 0px;
  right: 10px;
  left: 10px;
  z-index: -1;
  clip-path: polygon(20% 0%, 80% 0%, 100% 50%, 80% 100%, 20% 100%, 0% 50%);
  background: #fff;
}

.box-container .box i {
  color: #999;
  font-size: 40px;
  padding: 20px 0;
}

.box-container .box .title {
  font-size: 18px;
  text-transform: capitalize;
  color: #bc19e9;
  padding-bottom: 15px;
}

.box-container .box .counter {
  font-size: 30px;
  color: #999;
}

.box-container .box:nth-child(2)::before {
  background: #c0392b;
}

.box-container .box:nth-child(2) .title {
  color: #c0392b;
}

.box-container .box:nth-child(3)::before {
  background: #f39c12;
}

.box-container .box:nth-child(3) .title {
  color: #f39c12;
}

.box-container .box:nth-child(4)::before {
  background: #16a085;
}

.box-container .box:nth-child(4) .title {
  color: #16a085;
}
.box-container .box:nth-child(5)::before {
  background: #007bff;
}
.banner {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner video {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.banner .container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

ul {
  margin: 0px;
  padding: 0px;
}

.footer-section {
  background: #151414;
  position: relative;
}

.footer-cta {
  /* border-bottom: 1px solid #373636; */
}

.single-cta {
  text-align: center;
  padding-bottom: 50px;
}

.single-cta i {
  color: #ff5e14;
  font-size: 30px;
  margin-top: 8px;
}

.cta-text {
  padding-left: 15px;
  display: inline-block;
}

.cta-text h4 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 2px;
}

.cta-text span {
  color: #fff;
  font-size: 15px;
}

.footer-pattern img {
  position: absolute;
  top: 0;
  left: 0;
  height: 330px;
  background-size: cover;
  background-position: 100% 100%;
}

.footer-logo {
  margin-bottom: 30px;
}

.footer-logo img {
  max-width: 200px;
}

.footer-text p {
  margin-bottom: 14px;
  font-size: 14px;
  color: #7e7e7e;
  line-height: 28px;
}

.footer-social-icon span {
  color: #fff;
  display: block;
  font-size: 20px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
  margin-bottom: 20px;
}

.footer-social-icon a {
  color: #fff;
  font-size: 16px;
  margin-right: 15px;
}

.footer-social-icon i {
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 38px;
  border-radius: 50%;
}

.footer-widget-heading h3 {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 40px;
  position: relative;
}

.footer-widget-heading h3::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -15px;
  height: 2px;
  width: 50px;
  background: #ff5e14;
}

.footer-widget ul li {
  display: inline-block;
  float: left;
  width: 50%;
  margin-bottom: 12px;
}

.footer-widget ul li a:hover {
  color: #ff5e14;
}

.footer-widget ul li a {
  color: #878787;
  text-transform: capitalize;
}

.subscribe-form input {
  width: 100%;
  padding: 14px 28px;
  background: #2e2e2e;
  border: 1px solid #2e2e2e;
  color: #fff;
}

.subscribe-form button {
  position: absolute;
  right: 0;
  background: #ff5e14;
  padding: 13px 20px;
  border: 1px solid #ff5e14;
  top: 0;
}

.subscribe-form button i {
  color: #fff;
  font-size: 22px;
  transform: rotate(-6deg);
}

.copyright-text p {
  margin: 0;
  font-size: 14px;
  color: #878787;
}

.copyright-text p a {
  color: #ff5e14;
}

.footer-menu li {
  display: inline-block;
  margin-left: 20px;
}

.footer-menu li:hover a {
  color: #ff5e14;
}

.footer-menu li a {
  font-size: 14px;
  color: #878787;
}

.footer-section {
  position: absolute;
  width: 100%;
  height: 70vh;
  background-position: center;
  background-size: cover;
  background-image: linear-gradient(rgba(0, 0, 100, 0.6), rgba(0, 0, 100, 0.7)),
    url("../assets/adliya_footer.jpg");
  box-sizing: border-box;
}

@media (min-width: 280px) {
  .footer-section {
    height: 125vh;
  }
}

@media (min-width: 320px) {
  .footer-section {
    height: 145vh;
  }
}

@media (min-width: 360px) {
  .footer-section {
    height: 125vh;
  }
}

@media (min-width: 375px) {
  .footer-section {
    height: 110vh;
  }
}

@media (min-width: 411px) {
  .footer-section {
    height: 120vh;
  }
}

@media (min-width: 576px) {
  .footer-section {
    height: 100vh;
  }
}

@media (min-width: 768px) {
  .footer-section {
    height: 60vh;
  }
}

@media (min-width: 992px) {
  .footer-section {
    height: 70vh;
  }
}

@media (min-width: 912px) {
  .footer-section {
    height: 85vh;
  }
}

@media (min-width: 1024px) {
  .footer-section {
    height: 70vh;
  }
}

@media (min-width: 1200px) {
  .footer-section {
    height: 70vh;
  }
}

.bg-image {
  position: absolute;
  width: 100%;
  height: 70%;
  background-position: center;
  background-size: cover;
  background-image: linear-gradient(rgba(0, 0, 100, 0.6), rgba(0, 0, 100, 0.7)),
    url("../assets/adliya2.jpg");
  box-sizing: border-box;
}

.bg-image.overlay-primary:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 1;
}

.jobListSearch:active:after {
  overflow-y: 750px;
  transition: 0s;
}

.visitors-counter-container {
  padding-top: 15px;
  padding-bottom: 15px;
}

.visitors-counter-wrapper {
  padding-right: 15px;
  padding-left: 15px;
}
</style>
